import React from 'react';
import './ProductCard.css';

export function ProductCard({
  product,
  onProductClick,
  admin = false,
  draggable = false,
  isDragging = false,
  isDragOver = false,
  onDragStart,
  onDragOver,
  onDragLeave,
  onDrop,
  onDragEnd,
}) {
  if (!product) return null;

  const isInactive = admin && product.isActive === false;
  const isBundle = product.isBundle === true;

  const handleClick = () => {
    if (onProductClick) {
      onProductClick(product);
    }
  };

  return (
    <div
      className={`product-card ${isDragging ? 'product-card--dragging' : ''} ${isDragOver ? 'product-card--drag-over' : ''} ${isInactive ? 'product-card--inactive' : ''} ${isBundle ? 'product-card--bundle' : ''}`}
      onClick={handleClick}
      draggable={draggable}
      onDragStart={draggable ? (e) => onDragStart?.(e) : undefined}
      onDragOver={draggable ? (e) => onDragOver?.(e) : undefined}
      onDragLeave={draggable ? () => onDragLeave?.() : undefined}
      onDrop={draggable ? (e) => onDrop?.(e) : undefined}
      onDragEnd={draggable ? () => onDragEnd?.() : undefined}
    >
      {isInactive && (
        <div className="product-card-inactive-badge" title="Inactive product">
          <i className="fa-solid fa-eye-slash"></i>
        </div>
      )}
      {isBundle && (
        <div className="product-card-bundle-badge" title="Product bundle">
          <i className="fa-solid fa-layer-group"></i>
          <span>Bundle</span>
        </div>
      )}
      {draggable && (
        <div className="product-card-drag-handle" title="Drag to reorder">
          <i className="fa-solid fa-grip-vertical"></i>
        </div>
      )}
      {/* Square Product Image at Top */}
      <div className="product-image">
        {(product.thumbnail || product.image) ? (
          <img
            src={product.thumbnail || product.image}
            alt={product.name || 'Product'}
            className="product-image-src"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        ) : (
          <div className="product-image-placeholder">
            <i className="fa-solid fa-image"></i>
            <span>No Image</span>
          </div>
        )}
      </div>

      {/* Product Info Below Image */}
      <div className="product-info">
        <h3 className="product-name">{product.name || 'Unnamed Product'}</h3>

        {/* Product Price */}
        {(product.price !== undefined && product.price !== null) && (
          <div className="product-price">
            <span className="price-amount">
              {parseFloat(product.price) === 0 ? 'Free' : `$${product.price}`}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
